import { ReactNode } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { Box, Typography, styled } from '@mui/material';

import { FormElementProps } from '@/components';

export interface FormHeaderPositionToggleProps extends FormElementProps {
  label?: ReactNode;
}

const Root = styled(Box)(() => ({
  flex: 1,
  minWidth: '100%',
  maxWidth: '100%',
  marginBottom: 16,
}));

const ToggleContainer = styled(Box)({
  display: 'inline-flex',
  backgroundColor: '#F3F4F6',
  borderRadius: '8px',
  padding: '4px',
  gap: '4px',
});

const ToggleButton = styled('button')<{ active: boolean }>(({ active }) => ({
  padding: '6px 16px',
  border: 'none',
  borderRadius: '6px',
  fontSize: '14px',
  fontWeight: 500,
  cursor: 'pointer',
  transition: 'all 0.2s ease',
  backgroundColor: active ? '#ffffff' : 'transparent',
  color: active ? '#111827' : '#6B7280',
  boxShadow: active ? '0 1px 3px rgba(0, 0, 0, 0.1)' : 'none',
  '&:hover': {
    color: '#111827',
  },
}));

export const FormHeaderPositionToggle = (
  props: FormHeaderPositionToggleProps,
) => {
  const { label, name } = props;
  const { control } = useFormContext();

  return (
    <Root>
      {label && (
        <Typography
          variant="body2"
          sx={{ mb: 1, color: 'text.primary', fontSize: '0.875rem' }}
        >
          {label}
        </Typography>
      )}
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <ToggleContainer>
            <ToggleButton
              type="button"
              active={!field.value}
              onClick={() => field.onChange(false)}
            >
              First page only
            </ToggleButton>
            <ToggleButton
              type="button"
              active={field.value}
              onClick={() => field.onChange(true)}
            >
              All pages
            </ToggleButton>
          </ToggleContainer>
        )}
      />
    </Root>
  );
};
